import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4464088d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reports list" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-warning text-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-1 mb-2" }, "No reports found", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, "for the selected month or search", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "table table-hover"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "assignedtime" }, "Assigned Time"),
    /*#__PURE__*/_createElementVNode("th", { class: "assignedby" }, "Assigned By"),
    /*#__PURE__*/_createElementVNode("th", { class: "deadline" }, "Deadline"),
    /*#__PURE__*/_createElementVNode("th", { class: "date" }, "Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "ref" }, "Ref"),
    /*#__PURE__*/_createElementVNode("th", { class: "type" }, "Type"),
    /*#__PURE__*/_createElementVNode("th", { class: "address" }, "Address"),
    /*#__PURE__*/_createElementVNode("th", { class: "status" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "inputfiles" }, "Input files"),
    /*#__PURE__*/_createElementVNode("th", { class: "report" }, "Report"),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Actions")
    ])
  ])
], -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Download Report PDFs"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf" }, null, -1))
const _hoisted_15 = { class: "text-right" }
const _hoisted_16 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Actions"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]

import { ref, computed, inject, nextTick } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { Report, Auditlog, Booking, Document } from '@/models';
import { useToast } from "vue-toastification";
import ProgressButton from "@/components/ProgressButton.vue";
import ReportPagination from "@/components/report/ReportPagination.vue";
import DataentryStatus from '@/components/dataentry/DataentryStatus.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'DEList',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const store = useStore();
const toasted = useToast();

const actProperty: any = inject('actProperty');

const reportsState = computed(() => store.state.reports);
const dictionary = computed(() => store.getters['dictionary/current']);
const hasBlockingRequests = computed(() => store.getters['app/hasBlockingRequests']);
const reports = computed(() => store.getters['reports/list']);

const generateReportPdfAction = async (report: Report): Promise<any> => {
  await store.dispatch('reports/generateReportPdf', report);
};

const generateReportSummaryPdfAction = async (report: Report): Promise<any> => {
  await store.dispatch('reports/generateReportSummaryPdf', report);
};

const setCurrentPage = async (page: number) => {
  await store.dispatch('reports/setCurrentPage', page);
};

const removeRequest = (id: string) => {
  store.commit('app/removeRequest', id);
};

const setReports = (reports: Report[]) => {
  store.commit('app/setReports', reports);
};

const changestatusreportid = ref('');

function isDataentryReportEditable(report: Report) {
  if(report?.booking?.cancelled) return false;
  return true;
}

function getDataentryReportStyleClass(report: Report) {
  if(report?.booking?.cancelled) return 'cancelled-booking';
  return '';
}

function isCOSMActive(report: Report) {
  let result = true;
  if (report && report.customer && report.customer.reportsettings) {
    result =
      report &&
      report.customer &&
      report.customer.reportsettings.cosummaryactive;
  }
  return result;
}

function gotoReport(report: Report): void {
  router.push({ name: "dereport", params: { id: report.id || "" } });
}

function doReportsPaging(page: number): void {
  setCurrentPage(page);
  const queryParams = { ...route.query };
  queryParams.page = page + "";
  router.push({ path: "dereports", query: queryParams });
}

function generateReportPdf(report: Report, requestId: string): void {
  generateReportPdfAction(report)
    .then((key: string) => {
      actProperty.downloadAttachment(key);
      toasted.success(`Report ${report.ref} PDF downloaded`);
      nextTick(() => {
        setReports([...reports.value]);
      });
    })
    .finally(() => removeRequest(requestId))
    .catch((err: any) => actProperty.displayError(err));
}

function generateReportSummaryPdf(report: Report, requestId: string): void {
  generateReportSummaryPdfAction(report)
    .then((key: string) => {
      actProperty.downloadAttachment(key);
      toasted.success(`Report ${report.ref} Summary PDF downloaded`);
    })
    .finally(() => removeRequest(requestId))
    .catch((err: any) => actProperty.displayError(err));
}

function findCreatedBy(booking: Booking) {
  let createdby = '';
  if(booking?.auditlogs?.length) {
    let log = booking.auditlogs.find((l: Auditlog) => l.notes === 'Added booking');
    if(log) createdby = log.user;
  }
  return createdby;
}

function downloadDataentryInput(document: Document) {
  actProperty.downloadAttachment(document.src);
}

function getInputfileiconclass(document: Document) {
  let icon = 'fa-file';
  if(document.src.endsWith('pdf')) icon = 'fa-file-pdf';
  else if(document.src.endsWith('doc') || document.src.endsWith('docx')) icon = 'fa-file-word';
  return icon;
}

function formatBookingDatetimeForDisplay(report: Report) {
  if(report?.booking?.createdAt)
    return actProperty.formatUtcDatetimeForDisplay(report.booking.createdAt);
  else 
    return '';
}

function formatBookingStartdateForDisplay(report: Report) {
  if(report?.booking?.startdate)
    return actProperty.formatUtcDatetimeForDisplay(report.booking.startdate);
  else 
    return '';
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!reports.value.length && !hasBlockingRequests.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : (_openBlock(), _createElementBlock("table", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reports.value, (report, $index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: $index,
                class: _normalizeClass(getDataentryReportStyleClass(report))
              }, [
                _createElementVNode("td", null, _toDisplayString(formatBookingDatetimeForDisplay(report)), 1),
                _createElementVNode("td", null, [
                  (report && report.booking)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(findCreatedBy(report.booking)), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", null, _toDisplayString(formatBookingStartdateForDisplay(report)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(actProperty).formatDateForDisplay(report.date)), 1),
                _createElementVNode("td", null, _toDisplayString(report.ref), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(actProperty).formatReportType(report.type, dictionary.value)), 1),
                _createElementVNode("td", {
                  innerHTML: _unref(actProperty).formatAddress(report.address)
                }, null, 8, _hoisted_9),
                _createElementVNode("td", null, [
                  _createVNode(DataentryStatus, {
                    report: report,
                    changestatusreportid: changestatusreportid.value,
                    onStatusreportselected: _cache[0] || (_cache[0] = ($event: any) => (changestatusreportid.value = $event))
                  }, null, 8, ["report", "changestatusreportid"])
                ]),
                _createElementVNode("td", null, [
                  (report.booking && report.booking.dataentrydocuments)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(report.booking.dataentrydocuments, (document, $index) => {
                          return (_openBlock(), _createElementBlock("span", { key: $index }, [
                            _createElementVNode("button", {
                              class: "btn btn-outline-primary",
                              title: "Download dataentry input file",
                              onClick: ($event: any) => (downloadDataentryInput(document))
                            }, [
                              _createElementVNode("i", {
                                class: _normalizeClass(["far", getInputfileiconclass(document)])
                              }, null, 2)
                            ], 8, _hoisted_11)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(ProgressButton, {
                      onClick: ($event: any) => (_unref(actProperty).copyDownloadButton(report, 'report')),
                      onDblclick: ($event: any) => (generateReportPdf(report, $event)),
                      class: "btn btn-outline-primary",
                      title: _unref(actProperty).formatReportType(report.type, dictionary.value)
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 2
                    }, 1032, ["onClick", "onDblclick", "title"]),
                    (report.type == 'checkout')
                      ? (_openBlock(), _createBlock(ProgressButton, {
                          key: 0,
                          onClick: ($event: any) => (_unref(actProperty).copyDownloadButton(report, 'summary')),
                          onDblclick: ($event: any) => (generateReportSummaryPdf(report, $event)),
                          disabled: !isCOSMActive(report),
                          class: "btn btn-outline-primary",
                          title: "Check-Out Summary"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_14
                          ]),
                          _: 2
                        }, 1032, ["onClick", "onDblclick", "disabled"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("td", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    (isDataentryReportEditable(report))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-outline-primary",
                          onClick: ($event: any) => (gotoReport(report)),
                          title: "View"
                        }, _hoisted_19, 8, _hoisted_17))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 2))
            }), 128))
          ])
        ])),
    _createVNode(ReportPagination, {
      total: reportsState.value.monthlyReportCount,
      current: reportsState.value.currentPage,
      limit: reportsState.value.pageLimit,
      onPageReports: doReportsPaging
    }, null, 8, ["total", "current", "limit"])
  ]))
}
}

})